var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("ul", { staticClass: "account__logo" }, [
          _vm.clientData.logos && _vm.clientData.logos.medium
            ? _c(
                "li",
                [
                  _c("img", { attrs: { src: _vm.clientData.logos.medium } }),
                  _c("span", { staticClass: "img-container" }),
                  _c("gl-button", {
                    attrs: { round: "", "icon-center": "glicon-trash" },
                    on: {
                      onClick: function($event) {
                        $event.preventDefault()
                        return _vm.deleteLogo.apply(null, arguments)
                      }
                    }
                  })
                ],
                1
              )
            : _c("li", { staticClass: "account__logo--placeholder" }, [
                _c("span", { staticClass: "glicon-px-image" })
              ]),
          _c("li", [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "profile-guard",
                    rawName: "v-profile-guard",
                    value: "components.dataAccount.edit.editAccountLogo",
                    expression: "'components.dataAccount.edit.editAccountLogo'"
                  }
                ],
                on: {
                  click: function($event) {
                    _vm.openPopUp = true
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t(`account.edit.logo`)))]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "profile-guard",
                    rawName: "v-profile-guard",
                    value: "components.dataAccount.edit.editCampusLogo",
                    expression: "'components.dataAccount.edit.editCampusLogo'"
                  }
                ],
                staticClass: "checkbox small-check"
              },
              [
                _c("gl-checkbox", {
                  directives: [
                    {
                      name: "skeletor",
                      rawName: "v-skeletor:onChange",
                      value: _vm.setValue,
                      expression: "setValue",
                      arg: "onChange"
                    }
                  ],
                  attrs: {
                    id: "account.isShowedCampus",
                    label: _vm.$t(`account.edit.logoActions.showInCampus`),
                    checked: _vm.form.isShowedCampus,
                    small: true
                  },
                  model: {
                    value: _vm.form.isShowedCampus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "isShowedCampus", $$v)
                    },
                    expression: "form.isShowedCampus"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm.openPopUp
        ? _c("PopUpLogo", {
            attrs: { "size-in-mb": 5 },
            on: {
              "update-logo": data => _vm.$emit("update-logo", data),
              close: function($event) {
                _vm.openPopUp = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }